'use client';

import { useRouter } from 'next/router';
import React, { cloneElement, useCallback, useEffect, useState } from 'react';

import type { FC, MouseEventHandler, ReactElement } from 'react';

export interface RouteAnchorControllerProps {
  children: ReactElement<{
    anchorEl?: HTMLElement | null;
    onOpen?: MouseEventHandler;
  }>;

  anchorEl?: HTMLElement | null;
}

export const RouteAnchorController: FC<RouteAnchorControllerProps> = ({
  anchorEl: initialAnchorEl = null,
  children,
  ...props
}) => {
  const { pathname } = useRouter();

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>( initialAnchorEl );

  const handleActor = useCallback<MouseEventHandler<HTMLElement>>(
    (event) => setAnchorEl( event.currentTarget ),
    []
  );

  useEffect( () => {
    setAnchorEl( null );
  }, [pathname] );

  return (
    <>
      {cloneElement( children, { anchorEl, onOpen: handleActor, ...props } )}
    </>
  );
};
